import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { OperationResult } from '../../models/server-result/operation-result';
import { AppContextService } from '../../services/app-context.service';
import { LatestLegalDocumentsResult } from './documentation-api.models';

@Injectable()
export class DocumentationApiService {
	constructor(
		private http: HttpClient,
		private appContext: AppContextService,
		private domSanitizer: DomSanitizer
	) {}

	public latestLegalDocuments(languageCode: string): Observable<OperationResult<LatestLegalDocumentsResult>> {
		return this.http.get<OperationResult<LatestLegalDocumentsResult>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/documentation/latestLegalDocuments/' + languageCode)!
		);
	}
}
